export const DEFAULT_PRICE_TYPE_NAME = 'Bảng giá phổ thông';

export const getLineIdFromName = (lineName) => {
  const normalized = String(lineName ?? '').trim().toLowerCase();
  if (!normalized) return null;

  if (normalized === 'tmđt' || normalized === 'tmdt') return 1;
  if (normalized === 'line thường' || normalized === 'line thuong') return 4;
  if (normalized === 'line xt' || normalized === 'xách tay' || normalized === 'xach tay' || normalized === 'line xách tay' || normalized === 'line xach tay') return 11;
  if (normalized === 'line vat' || normalized === 'line chính ngạch' || normalized === 'line chinh ngach') return 12;

  return null;
};

export const resolveDefaultPriceTypeName = (contact, lineName) => {
  const lineId = getLineIdFromName(lineName);
  if (!lineId) return DEFAULT_PRICE_TYPE_NAME;

  const priceTypes = Array.isArray(contact?.priceTypes) ? contact.priceTypes : [];
  const defaultPriceType = priceTypes.find(
    (item) => item?.lineId === lineId && item?.isDefault,
  );

  return defaultPriceType?.name || DEFAULT_PRICE_TYPE_NAME;
};
